/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* On-demand throughput settings for the global secondary index.
*/
export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput {
  /**
  * The maximum number of strongly consistent reads consumed per second before DynamoDB returns a ThrottlingException.
  */
  'readCapacityUnits'?: number | null;
  /**
  * The maximum number of writes consumed per second before DynamoDB returns a ThrottlingException.
  */
  'writeCapacityUnits'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "readCapacityUnits",
      "baseName": "readCapacityUnits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "writeCapacityUnits",
      "baseName": "writeCapacityUnits",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput.attributeTypeMap;
  }

  public constructor() {
  }
}

